import { ReportingControllerBaseConfig } from '../../../../base';
import { SnippetInputNewController } from './snippetNewInterface';
import { SnippetInputNewViewProps } from './snippetNewProps';

export function createSnippetInputNewController(
    config: ReportingControllerBaseConfig
): SnippetInputNewController {
    return {
        useProps(context, props): SnippetInputNewViewProps {
            return {
                input: {
                    label: 'Snippet',
                    textarea: {
                        autoFocus: true,
                        value: props.field.content.value ?? '',
                        onChange(event) {
                            console.log('onChange', event.target.value);
                            props.field.content.onChange(event.target.value ?? null);
                        },
                    },
                    save: {
                        label: 'Save',
                        button: {
                            isLoading: props.isSubmitting,
                            onClick: props.onSave,
                        },
                    },
                    cancel: {
                        label: 'Cancel',
                        button: {
                            onClick: props.onClose,
                        },
                    },
                },
            };
        },
    };
}
